export const PREFIX_URL = '/imobiliarias';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
